import React, { useState,useContext } from "react";
import "./ProblemManagement.css";
import { AuthContext } from "../../../../context/authContext";
import { GettingProblemByReferenceCode } from "../../../../Functions/CRUD/Problem/problemHelper";
import LoadingPage from "../../../../Error/LoadingPage/LoadingPage";
import ProblemEditLayout from "./ProblemEditLayout/ProblemEditLayout";
import ProblemSolutions from "./ProblemSolutionSubmission/ProblemSolutions";
const ProblemManagement = () => {
  const { user } = useContext(AuthContext);
  const [Search, setSearch] = useState("");
  const [Loading, setLoading] = useState(false);
  const [problem, setproblem] = useState(null);
  const [Message, setMessage] = useState(null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = await GettingProblemByReferenceCode(Search);
      if (!data.found) {
        setMessage(data.message);
        setproblem(null);
        console.log(Message);
        setLoading(false);
        return;
      }
      setLoading(false);
      setMessage(null);
      setproblem(data.Problem);
      console.log(problem);
    } catch (error) {
      setMessage("Problem fetch failed");
    }
  };

  return (
    <div className="ProblemManagement-container">
      {Loading ? (
        <LoadingPage />
      ) : (
        <>
          <div className="Intro">
            <h1>🐲 Problem Management Center :</h1>
            <p>
              <b>Instructions : </b>
              In this section you may look up problems using the reference code
              of the problem. Also, you may correct errors in problem
              statements. It is highly adviseable to consult the "Report"
              section to figure out which problem requires interferance and
              correction. We also encourage dicussing any changes before hand
              with fellow colleages to be as accurate as possible.
            </p>
          </div>

          <div className="ProblemManagement-Body">
            <form action="" onSubmit={handleSubmit}>
              <label htmlFor="">Look up Problem by reference code :</label>
              <input
                value={Search}
                type="text"
                onChange={(e) => setSearch(e.target.value)}
              />
              <button type="submit">Search</button>
            </form>

            <div className="Content">
              {problem ? (
                <>
                <ProblemEditLayout setLoading={setLoading} problem={problem} />
                <div className="Solutions">
              {user.role.toLowerCase()!=="student"?<ProblemSolutions problem={problem} setLoading={setLoading}/>:null}
            </div></>
                
              ) : Message ? (
                <p className="Error">{Message}</p>
              ) : null}
            </div>

            

            <div className="Directions">
              <span>
                <b>Bare in mind : </b> The reference code are designed as follow
                : "X-Y-NN...N" where :
                <br />
                <ul>
                  <li>
                    <b>X : </b> is either "U" or "D" or "W" each refering to
                    "Unit" or "Daily" or "Weekly", respectively
                  </li>
                  <li>
                    <b>Y : </b>is either "A" or "C" or "G" or "N" refering to
                    the field of the problem as "Algebra", "Combinatorics" or
                    "Geomerty" or "Number Theroy", respectively
                  </li>
                  <li>
                    <b>NN...N : </b> is a set of numbers where it is :
                    <ul>
                      <li>
                        DDMMYYYY (i.e the actual date of submission) for{" "}
                        <i>Dailys.</i>
                      </li>
                      <li>
                        Arbitralily for <i>Units.</i>
                      </li>
                      <li>
                        NNMMYYYY (the number of the problem and it's month) for{" "}
                        <i>Weeklys.</i>
                      </li>
                    </ul>
                  </li>
                </ul>
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProblemManagement;
